import React from 'react';

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white py-5 mt-5">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold mb-3">Combine Shipping</h6>
            <p className="text-white-50 small">Nepal's leading platform for shared shipping space.</p>
          </div>
          <div className="col-lg-2 col-md-6">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <div className="d-flex flex-column gap-2">
              <a href="#" className="text-white-50 small">Track</a>
              <a href="#" className="text-white-50 small">Book</a>
              <a href="#" className="text-white-50 small">Services</a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold mb-3">Help & Support</h6>
            <div className="d-flex flex-column gap-2">
              <a href="#" className="text-white-50 small">Contact Us</a>
              <a href="#" className="text-white-50 small">FAQ</a>
              <a href="#" className="text-white-50 small">Live Chat</a>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <h6 className="fw-bold mb-3">Social</h6>
            <div className="d-flex gap-3 mb-3">
              <a href="#" className="text-white-50 fs-4"><i className="fab fa-facebook-f"></i></a>
              <a href="#" className="text-white-50 fs-4"><i className="fab fa-twitter"></i></a>
              <a href="#" className="text-white-50 fs-4"><i className="fab fa-instagram"></i></a>
              <a href="#" className="text-white-50 fs-4"><i className="fab fa-whatsapp"></i></a>
            </div>
            <p className="text-white-50 small mb-0">Privacy Policy | Terms of Service</p>
          </div>
        </div>
        <div className="text-center mt-4 pt-3 border-top border-secondary">
          <p className="mb-0 text-white-50 small">&copy; 2026 Combine Shipping. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
